import { render, staticRenderFns } from "./TxtSlider.vue?vue&type=template&id=0471094e&scoped=true&"
import script from "./TxtSlider.vue?vue&type=script&lang=js&"
export * from "./TxtSlider.vue?vue&type=script&lang=js&"
import style0 from "./TxtSlider.vue?vue&type=style&index=0&id=0471094e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0471094e",
  null
  
)

export default component.exports